<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HamburgerButton",
});
</script>

<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.421875" y="2" width="24" height="2.4" fill="#0F0F0F"/>
    <rect x="0.421875" y="10.4004" width="24" height="2.4" fill="#0F0F0F"/>
    <rect x="0.421875" y="18.8008" width="24" height="2.4" fill="#0F0F0F"/>
  </svg>
</template>

<style scoped lang="scss">

</style>